import { createUseStyles } from 'react-jss';

const styles = {
  illustratedMessage: {
    display: 'flex',
    justifyContent: 'center',
    height: 'calc(100vh - 10rem)'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'ErrorPage'
});
